module.exports = __webpack_public_path__ + "img/app_store.6de41fa2.svg";